import { defaultUnpatchedConsole } from './const';
export let unpatchedConsole = defaultUnpatchedConsole;
export function initializeUnpatchedConsole(config) {
    var _a;
    unpatchedConsole = (_a = config.unpatchedConsole) !== null && _a !== void 0 ? _a : unpatchedConsole;
    return unpatchedConsole;
}
//# sourceMappingURL=initialize.js.map